import React, { useState } from "react";
import { useContent } from "../../../contexts/contentContext/contentContext.js";

const MoreQuestionsNew = ({ questionsList, questionDetails }) => {
  const [limitQuestions, setLimitQuestions] = useState(10);
  const [showMore, setShowMore] = useState(true);
  const {  getTextByKey } = useContent();

  const ShowMoreQuestions = () => {
    setShowMore(false);
    setLimitQuestions(questionsList && questionsList.length);
  };
  return (
    <div className="support-side-list">
      <h3>{getTextByKey("more-questions")}</h3>
      {questionsList &&
        questionsList.slice(0, limitQuestions).map((quetion, i) => {
          const quetionRoute =
            quetion.SystemName === "jumbo-embed"
              ? "jumbo-forms"
              : quetion.SystemName
              ? quetion.SystemName.replace(/\s+/g, "-").toLowerCase()
              : "";
          return (
            <a
              href={`${quetionRoute}`}
              key={quetion && quetion.SupportCategoryQuestionId}
              className="question-padding"
            >
              <div
                key={i}
                className={
                  quetion &&
                  questionDetails &&
                  questionDetails.Title === quetion.Title
                    ? "support-question-color"
                    : null
                }
              >
                {quetion && quetion.Title}
              </div>
            </a>
          );
        })}
      {showMore ? (
        <div
          className="show-more-link"
          onClick={() => {
            ShowMoreQuestions();
          }}
        >
          {getTextByKey("show-more-support")}
        </div>
      ) : null}
    </div>
  );
};

export default MoreQuestionsNew;
